import { f7, useStore } from 'framework7-react';
import { usePaymentList } from './api/payment/usePaymentList';
import { useToast } from './useToast';
import { customerInfoApi } from '@/api/customerApi';
import { AuthInfoState, initialState } from '@/config/initialState';
import { store } from '@/config/store';
import { paymentStorage } from '@/utils/paymentStorage';
import { selectedTenantFor } from '@/utils/selectedTenant';
import { dispatchBasicInfo, storeDispatch } from '@/utils/store';

export const useGmoRegisterAndEditRedirect = () => {
  const router = f7.views.main.router;
  const authInfo = useStore(store, 'authInfo') as AuthInfoState;
  const customerId = paymentStorage.getItem('m_customer_id');
  const token = paymentStorage.getItem('token');
  const { openToast } = useToast();
  const { updatePaymentList } = usePaymentList(false);

  const fetchAndSetCustomerInfo = async (mCustomerId: string | null) => {
    if (!mCustomerId) return;
    try {
      const requestAuth = store.state.authInfo;
      if (requestAuth.m_customer_id !== Number(mCustomerId)) return;
      // カード一覧は顧客単位だが、顧客情報は現在の表示先法人で再取得する。
      const requestedTenantId =
        selectedTenantFor(requestAuth.m_customer_id)?.m_affiliate_id ?? null;
      const { data: customerInfo, requestedAffiliateId } =
        await customerInfoApi(
          {
            m_customer_id: Number(mCustomerId),
          },
          { applySelectedTenant: requestedTenantId !== null },
        );
      if (
        !customerInfo?.success ||
        customerInfo.customer?.id !== requestAuth.m_customer_id ||
        store.state.authInfo.m_customer_id !== requestAuth.m_customer_id ||
        store.state.authInfo.token !== requestAuth.token ||
        (selectedTenantFor(requestAuth.m_customer_id)?.m_affiliate_id ??
          null) !== requestedTenantId
      )
        return;
      await dispatchBasicInfo(customerInfo, requestedAffiliateId);
      const { cars } = customerInfo;
      await Promise.all([
        storeDispatch(
          'setCarItemInfo',
          'carItemInfo',
          cars?.[0] || initialState.carItemInfo,
        ),
        storeDispatch(
          'setWarranties',
          'warranties',
          cars?.[0]?.warranties || [],
        ),
        storeDispatch(
          'setNextWarranties',
          'nextWarranties',
          cars?.[0]?.next_warranty || [],
        ),
        storeDispatch(
          'setCurrentWarranty',
          'currentWarranty',
          cars?.[0]?.warranties?.[0],
        ),
        storeDispatch(
          'setNextWarranty',
          'nextWarranty',
          cars?.[0]?.next_warranty?.[0],
        ),
      ]);
    } catch (e) {
      console.error('GMOリダイレクト後の顧客情報取得に失敗しました', e);
    }
  };

  const handleGmoRegisterAndEditRedirect = async (
    status: string,
    isLoggedIn: boolean,
  ) => {
    if (!isLoggedIn) return;
    const mCustomerId = paymentStorage.getItem('m_customer_id');

    switch (status) {
      case 'gmo_success':
        await fetchAndSetCustomerInfo(mCustomerId);
        if (
          !mCustomerId ||
          Number(mCustomerId) !== store.state.authInfo.m_customer_id
        )
          return;
        // 同じ画面から二度目以降に戻った場合も GMO で変わったカードを取り直す。
        await updatePaymentList(Number(mCustomerId));
        openToast(
          'カードの登録・編集が完了しました。',
          'toast-success',
          3000,
          true,
          'top',
        );
        return;
      case 'gmo_cancel':
        openToast(
          'カードの登録・編集がキャンセルされました。',
          'toast-failed',
          3000,
          true,
          'top',
        );
        break;
    }
  };

  return {
    handleGmoRegisterAndEditRedirect,
  };
};
